import src from "IMAGE";
export default { src, width: 230, height: 200, blurWidth: 8, blurHeight: 7, blurDataURL: "data:image/webp;base64,UklGRnQAAABXRUJQVlA4TGcAAAAvB4ABAM1VICICHgiADQIAAIAR0AFAQCHACQiQoDgcEMABBIEAAbhAAAKEQEAAAQiiAAlCnQsgSeQUAAAgIvJ721IVDqimCiID/qF2x0lbr+7s0ZykC7ZYHvuZ7fEQEWre+yM3cUgdAA=="};
